export interface UtilsItem {
    data: any;
    key: string;
    value: string | null;
    value_boolean: boolean | null;
}

export interface UtilsResponse {
    data: {
        utils: UtilsItem[];
    };
}

export class UtilsService {
    private utilsDB: UtilsItem[] = [];

    async fetchUtils(): Promise<void> {
        try {
            const basePath = process.env.NEXT_PUBLIC_HASURA_BASEPATH || 'https://dev-api.babalucloud.it';
            const graphqlUrl = `${basePath}/v1/graphql`;

            const response = await fetch(graphqlUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: `query getUtils {
                        utils {
                            data
                            key
                            value
                            value_boolean
                        }
                    }`
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch utils');
            }

            const result: UtilsResponse = await response.json();
            this.utilsDB = result.data.utils;
        } catch (error) {
            console.error('Error fetching utils:', error);
            this.utilsDB = [];
        }
    }

    checkUtils(key: string, type: 'string' | 'boolean'): string | boolean | false {
        const res = this.utilsDB?.find(item => item.key === key);
        if (!res) {
            return false;
        }

        switch (type) {
            case 'string':
                return res.value || false;
            case 'boolean':
                return !!res.value_boolean;
            default:
                return false;
        }
    }

    async getCurrentVersions(): Promise<{ privacyVersion: string; termsVersion: string; analyticsVersion: string }> {
        await this.fetchUtils();
        
        const privacyVersion = this.checkUtils('privacy_version', 'string') as string || '1';
        const termsVersion = this.checkUtils('terms_version', 'string') as string || '1';
        const analyticsVersion = this.checkUtils('analytics_version', 'string') as string || '1';
        
        return {
            privacyVersion,
            termsVersion,
            analyticsVersion
        };
    }

    async getAddressFromCoordinates(lat: number, lng: number): Promise<string | null> {
        // const googleApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
        
        try {
            // if (googleApiKey) {
            //     // Use Google Geocoding API if key is available
            //     const response = await fetch(
            //         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}&language=it`
            //     );
                
            //     if (response.ok) {
            //         const data = await response.json();
            //         if (data.results && data.results.length > 0) {
            //             return data.results[0].formatted_address;
            //         }
            //     }
            // }
            
            // Fallback to Nominatim (OpenStreetMap) - no API key required
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=it&addressdetails=1`
            );
            
            if (response.ok) {
                const data = await response.json();
                if (data.display_name) {
                    return data.display_name;
                }
            }
            
            // Final fallback
            return null;
            
        } catch (error) {
            console.error('Error getting address from coordinates:', error);
            return null;
        }
    }
}

export const utilsService = new UtilsService();